// Clasificación del resultado de un examen de curso según el porcentaje de
// aciertos. Se usa tanto en la vista del talento (Academia) como en el
// seguimiento del master.

// Con 75% o más el examen se considera completado y no puede volver a rendirse.
export const EXAM_COMPLETED_THRESHOLD = 75

export const EXAM_RESULT_LEVELS = {
  good: {
    key: 'good',
    label: 'Bien',
    emoji: '🎉',
    color: '#00cf83',
    message: '¡Salió bien! Dominas el contenido del curso.',
  },
  regular: {
    key: 'regular',
    label: 'Regular',
    emoji: '💪',
    color: '#c98a1a',
    message: 'Salió regular. Repasa las clases para mejorar tu resultado.',
  },
  bad: {
    key: 'bad',
    label: 'Mal',
    emoji: '📚',
    color: '#ff5b5b',
    message: 'Salió mal. Te recomendamos volver a ver las clases del curso.',
  },
}

// Umbrales: >= 75% bien, >= 50% regular, < 50% mal.
export const getExamResultLevel = (percentage) => {
  const pct = Number(percentage) || 0
  if (pct >= EXAM_COMPLETED_THRESHOLD) return EXAM_RESULT_LEVELS.good
  if (pct >= 50) return EXAM_RESULT_LEVELS.regular
  return EXAM_RESULT_LEVELS.bad
}

// ---- Helpers para el "progress" del backend ----
// Forma de cada entrada (una por curso):
// {
//   courseId, courseTitle, finalGrade,
//   questions: [{ questionId, question, qualification }]
// }

export const findCourseProgress = (progress = [], courseId) =>
  (Array.isArray(progress) ? progress : []).find(
    (entry) => Number(entry?.courseId) === Number(courseId)
  ) || null

// Un examen queda completado (y no vuelve a rendirse) con finalGrade >= 75.
export const isExamCompleted = (entry) =>
  Number(entry?.finalGrade) >= EXAM_COMPLETED_THRESHOLD
